/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

export enum FeatureToggleKey {
  EnableFlexiblePricing = "enableFlexiblePricing",
  EnableForwardSettlementDecoupling = "enableForwardSettlementDecoupling",
  EnableCrossRegistryForwardTrading = "enableCrossRegistryForwardTrading",
}

// TX-2262 - Keeping default value if the .env variable is not set
export const CONFIGCAT_CACHE_TTL_DEFAULT = 60 * 60 * 24;

/**
 * @example
 * {
 * [FeatureToggleKey.Something]: 'Something' (from config cat)
 * }
 */
export const FeatureToggleKeyMap: Record<FeatureToggleKey, string> = {
  [FeatureToggleKey.EnableFlexiblePricing]: "enableflexiblepricing_20250711",
  [FeatureToggleKey.EnableForwardSettlementDecoupling]: "enableforwardsettlementdecoupling_20250911",
  [FeatureToggleKey.EnableCrossRegistryForwardTrading]: "enableforwardtradecrossregistrymatch_251008",
};

export type UseAllFeatureToggleValues = () => {
  toggles: Record<FeatureToggleKey, any>; // useFeatureFlag (config-cat) returns value as any
  loading: boolean;
};
